/**
 * SideNavMenuItem.tsx — underlenke i side-nav meny
 *
 * Ren React-komponent som erstatter cds-side-nav-menu-item.
 * Bruker next/link for ruting.
 *
 * Props:
 * - href: rute-lenke
 * - active: om siden er åpen (markeres som valgt)
 * - children: lenketekst
 */

import Link from 'next/link';
import styles from './side-nav-menu-item.module.scss';

interface SideNavMenuItemProps {
  href: string;
  active?: boolean;
  children: React.ReactNode;
}

export default function SideNavMenuItem({ href, active = false, children }: SideNavMenuItemProps) {
  return (
    <li className={styles.item}>
      <Link href={href} className={active ? styles.linkActive : styles.link} aria-current={active ? 'page' : undefined}>
        {children}
      </Link>
    </li>
  );
}
